"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronRightDouble = function ChevronRightDouble(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("path", {
    d: "M12.1317 5.88181C12.0834 5.93018 12.045 5.98759 12.0188 6.05078C11.9926 6.11398 11.9792 6.1817 11.9792 6.2501C11.9792 6.3185 11.9926 6.38623 12.0188 6.44942C12.045 6.51261 12.0834 6.57002 12.1317 6.61839L18.0135 12.5001L12.1317 18.3818C12.034 18.4795 11.9792 18.6119 11.9792 18.7501C11.9792 18.8882 12.034 19.0207 12.1317 19.1184C12.2294 19.216 12.3619 19.2709 12.5 19.2709C12.6381 19.2709 12.7706 19.216 12.8683 19.1184L19.1183 12.8684C19.1667 12.82 19.205 12.7626 19.2312 12.6994C19.2574 12.6362 19.2708 12.5685 19.2708 12.5001C19.2708 12.4317 19.2574 12.3639 19.2312 12.3008C19.205 12.2376 19.1667 12.1801 19.1183 12.1318L12.8683 5.88178C12.8199 5.83342 12.7625 5.79506 12.6993 5.76889C12.6361 5.74271 12.5684 5.72925 12.5 5.72925C12.4316 5.72925 12.3639 5.74273 12.3007 5.7689C12.2375 5.79508 12.1801 5.83345 12.1317 5.88181Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M7.96505 5.88181C7.91668 5.93018 7.87832 5.98759 7.85214 6.05078C7.82597 6.11398 7.8125 6.1817 7.8125 6.2501C7.8125 6.3185 7.82597 6.38623 7.85214 6.44942C7.87832 6.51261 7.91668 6.57002 7.96505 6.61839L13.8468 12.5001L7.96505 18.3818C7.86737 18.4795 7.8125 18.6119 7.8125 18.7501C7.8125 18.8882 7.86737 19.0207 7.96505 19.1184C8.06272 19.216 8.1952 19.2709 8.33334 19.2709C8.47147 19.2709 8.60395 19.216 8.70162 19.1184L14.9516 12.8684C15 12.82 15.0384 12.7626 15.0645 12.6994C15.0907 12.6362 15.1042 12.5685 15.1042 12.5001C15.1042 12.4317 15.0907 12.3639 15.0645 12.3008C15.0384 12.2376 15 12.1801 14.9516 12.1318L8.70162 5.88178C8.65326 5.83342 8.59584 5.79506 8.53265 5.76889C8.46946 5.74271 8.40173 5.72925 8.33333 5.72925C8.26493 5.72925 8.19721 5.74273 8.13402 5.7689C8.07083 5.79508 8.01341 5.83345 7.96505 5.88181Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: "white"
  }))));
};

ChevronRightDouble.defaultProps = {
  altText: "ChevronRightDouble",
  foregroundColor: "#2D5AB4"
};
ChevronRightDouble.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ChevronRightDouble;
exports.default = _default;